import React, { ElementType } from 'react'
import { twMerge } from 'tailwind-merge'
import SkeletonMaterial, { SkeletonProps as SkeletonMaterialProps } from '@mui/material/Skeleton'

type SkeletonProps = SkeletonMaterialProps & {
  component?: ElementType
  fullHeight?: boolean
  fullWidth?: boolean
}

const Skeleton: React.FC<SkeletonProps> = props => {
  const {
    animation,
    children,
    classes,
    className,
    component = 'span',
    fullHeight,
    fullWidth,
    height,
    variant,
    width
  } = props
  return (
    <SkeletonMaterial
      animation={animation}
      classes={classes}
      className={twMerge(className, fullWidth && 'w-full', fullHeight && 'h-full')}
      component={component}
      height={height}
      variant={variant}
      width={width}
    >
      {children}
    </SkeletonMaterial>
  )
}

export default Skeleton
